import type { Editor } from 'slate';

import React, { createContext, useContext, useMemo, useState } from 'react';

interface CustomBlockFormContextValue {
  editor: Editor | null;
  isDirty: boolean;
  setEditor: (editor: Editor) => void;
  setIsDirty: (isDirty: boolean) => void;
}

const EditorContext = createContext<CustomBlockFormContextValue>({
  isDirty: false,
  editor: null,
  setIsDirty: () => {},
  setEditor: () => {},
} as CustomBlockFormContextValue);

export default function CustomBlocksEditorContext({ children }: React.PropsWithChildren<unknown>) {
  const [editor, setEditor] = useState<Editor | null>(null);
  const [isDirty, setIsDirty] = useState(false);

  const value = useMemo(() => ({ editor, setEditor, isDirty, setIsDirty }), [isDirty, editor]);

  return <EditorContext.Provider value={value}>{children}</EditorContext.Provider>;
}

export const useCustomBlockEditorContext = () => useContext(EditorContext);
